import { useOnbPartnerForm } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useOnbPartnerForm'
import { OnbPartnerForm } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/OnbPartnerForm'

import { IPartner, IPartnerFlags } from 'clickNgo/entities/partner/models'
import { IAttachment } from 'clickNgo/models/file'

interface IOnbFormDialogContentProps {
  partner: IPartner
  partnerFlags: IPartnerFlags
  partnerAttachments: IAttachment[]
  isDisabled?: boolean
  appSource: string
}

export const OnbFormDialogContent = ({
  partner,
  partnerAttachments,
  partnerFlags,
  appSource,
  isDisabled,
}: IOnbFormDialogContentProps) => {
  const { actualData, isInactive, isLoading } = useOnbPartnerForm({
    partnerAttachments,
    partner,
    partnerFlags,
    appSource,
  })

  return (
    <OnbPartnerForm
      isDisabled={isDisabled}
      partner={actualData.partner}
      isInactive={isInactive}
      isLoading={isLoading}
    />
  )
}
